// Data storage helpers for feature modules.
export type ModuleDataMode = 'PUBLIC' | 'USER_GLOBAL' | 'USER_LOCAL' | 'USER_READ_GLOBAL';

// ModuleData is used to store data that is specific to particular module.
// A module should only even access data for it's own module.


export type ModuleGlobal<T> = {
    mode: ModuleDataMode,
    moduleKey: string,
    globalName: string | null,
} & {__T: T}

export function defineModuleGlobal<T>(
    mode: ModuleDataMode, moduleKey: string, 
    globalName: string | null) : ModuleGlobal<T> {
    return {
        mode,
        moduleKey,
        globalName,
    } as ModuleGlobal<T>
}

export type ModuleMap<T> = {
    mode: ModuleDataMode,
    moduleKey: string,
    mapName: string | null,
} & {__T: T}

export function defineModuleMap<T>(
    mode: ModuleDataMode, moduleKey: string, 
    mapName: string | null) : ModuleMap<T> {
    return {
        mode,
        moduleKey,
        mapName,
    } as ModuleMap<T>
}

export type ModuleMapMap<T> = {
    mode: ModuleDataMode,
    moduleKey: string,
    mapMapName: string | null,
} & {__T: T}

export function defineModuleMapMap<T>(
    mode: ModuleDataMode, moduleKey: string, 
    mapMapName: string | null = null) : ModuleMapMap<T> {
    return {
        mode,
        moduleKey,
        mapMapName,
    } as ModuleMapMap<T>
}


// Define some legacal module data that didn't honor the per-module isolation rules
// TODO: Migrate these into components

export const moduleAdminLinks = defineModuleMap<string>("PUBLIC", 'admin', 'links');
